/**
 * @since 2026-04-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import "./ConfirmationDialog.scss";

const ConfirmationDialog = ({
  open,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "primary",
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className="confirmationDialog"
      PaperProps={{ className: "dialogPaper" }}
    >
      <DialogTitle className="dialogTitle">
        <Typography variant="h6" component="div">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent className="dialogContent">
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      <DialogActions className="dialogActions">
        <Button onClick={onCancel} className="cancelButton">
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          className={`confirmButton ${variant === "danger" ? "danger" : "primary"}`}
          variant="contained"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
